import {List} from 'immutable';
import { ATUALIZAR_STATUS_VENDA_LOTE, CARREGAR_LOTES_VENDA_STORE } from '../constants/constants';

function outterVendas(state, action){
    switch(action.type){
        case CARREGAR_LOTES_VENDA_STORE:
            return List (action.lotes)
    }
    return state;
}

export default (vendasStateOld = List([]), action)=>{
    const vendasState = outterVendas(vendasStateOld, action);

    switch(action.type){
        case ATUALIZAR_STATUS_VENDA_LOTE:
            return vendasState.set(action.id, {...vendasState.get(action.id), disponibilidade : action.disponibilidade})
    }
    return vendasState;
}


// WEBPACK FOOTER //
// ./src/reducers/vendas.js